module.exports = __webpack_public_path__ + "static/media/posted-decisions.423dbfb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/posted-decisions.jpg
// module id = 2669
// module chunks = 0